import React from "react";
import classes from "../style/Style.module.css";
import "../style/Welcomescreens.scss";
import panLogo from "../Images/Magnetic Card.svg";
import BankLogo from "../Images/Bank Account.svg";
import { useNavigate } from "react-router-dom";
import { ROUTE_PAN_VERIFICATION } from "../Routes";

const StartKycHome = () => {
  const Navigate = useNavigate();
    const HandlerSubmit = ()=>{
      Navigate(ROUTE_PAN_VERIFICATION)
  }
  return (
    <div className="StartKycHome_Container">
      <div className="KYC_Info_Container">
        <p className="Container_Header">
          <span className="Header_Text">
            To start investing,
            <br />
            complete your  KYC.
          </span>
         
        </p>
        <div className="Documents_Container">
          <p className="Verify_Pan_Box">
            <img src={panLogo} alt="Panlogo" />
            <p className="Text_Container">
              <span className="Verfiy_Pan_Text">Verify PAN Card</span>
              <span className="Verfiy_Pan_SubText">
                Link your PAN to your Dexterr account
              </span>
            </p>
          </p>
          <p className="Verify_BankAC_Box">
            <img src={BankLogo} alt="Banklogo" />
            <p className="Text_Container">
              <span className="Verfiy_Pan_Text">
                Verify Bank Account
              </span>
              <span className="Verfiy_Pan_SubText">
              Enter the account for your investment transaction.
              </span>
            </p>
          </p>
          <button className="Kyc_Home_Btn" onClick={HandlerSubmit}>
            Let’s do it
            <br />
            <span className="button_inner_text">
            Takes only a few minutes
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartKycHome;
